import { createAction, props } from '@ngrx/store';
import { MspCwmCreds } from './model';

export const loadMspCwmCreds = createAction('[MSP CWM] Load Creds');
export const loadMspCwmCredsSuccess = createAction(
    '[MSP CWM] Load Creds Success',
    props<{ data: MspCwmCreds; connected: boolean }>(),
);
export const loadMspCwmCredsFailure = createAction('[MSP CWM] Load Creds Failure', props<{ error: any }>());

export const createMspCwmCreds = createAction('[MSP CWM] Create Creds', props<{ data: MspCwmCreds }>());
export const createMspCwmCredsSuccess = createAction('[MSP CWM] Create Creds Success', props<{ data: MspCwmCreds }>());
export const createMspCwmCredsFailure = createAction('[MSP CWM] Create Creds Failure', props<{ error: any }>());

export const putMspCwmCreds = createAction('[MSP CWM] Put Creds', props<{ data: MspCwmCreds }>());
export const putMspCwmCredsSuccess = createAction('[MSP CWM] Put Creds Success', props<{ data: MspCwmCreds }>());
export const putMspCwmCredsFailure = createAction('[MSP CWM] Put Creds Failure', props<{ error: any }>());

export const deleteMspCwmIntegration = createAction('[MSP CWM] Delete Integration');
export const deleteMspCwmIntegrationSuccess = createAction('[MSP CWM] Delete Integration Success');
export const deleteMspCwmIntegrationFailure = createAction(
    '[MSP CWM] Delete Integration Failure',
    props<{ error: any }>(),
);
